/* eslint-disable no-param-reassign */
import produce from 'immer';
import {
  GET_BIRTHDAY_MESSAGE_SENDING_STRATEGY,
  GET_BIRTHDAY_MESSAGE_SENDING_STRATEGY_SUCCESS,
  GET_BIRTHDAY_MESSAGE_SENDING_STRATEGY_ERROR,
  GET_BIRTHDAY_MESSAGE_SETTINGS,
  GET_BIRTHDAY_MESSAGE_SETTINGS_SUCCESS,
  GET_BIRTHDAY_MESSAGE_SETTINGS_ERROR,
  UPDATE_BIRTHDAY_MESSAGE_SETTINGS,
  UPDATE_BIRTHDAY_MESSAGE_SETTINGS_SUCCESS,
  UPDATE_BIRTHDAY_MESSAGE_SETTINGS_ERROR,
} from 'src/actions/birthdayMessageActions';

const birthdayMessageSendingStrategy = {
  loading: false,
  data: [],
};

const initialState = {
  loading: false,
  birthdayMessage: null,
  birthdayMessageSendingStrategy,
};

const birthdayMessageReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_BIRTHDAY_MESSAGE_SENDING_STRATEGY: {
      return produce(state, (draft) => {
        draft.birthdayMessageSendingStrategy.loading = true;
      });
    }

    case GET_BIRTHDAY_MESSAGE_SENDING_STRATEGY_SUCCESS: {
      return produce(state, (draft) => {
        draft.birthdayMessageSendingStrategy.data = payload || birthdayMessageSendingStrategy.data;
        draft.birthdayMessageSendingStrategy.loading = false;
      });
    }

    case GET_BIRTHDAY_MESSAGE_SENDING_STRATEGY_ERROR: {
      return produce(state, (draft) => {
        draft.birthdayMessageSendingStrategy = birthdayMessageSendingStrategy;
      });
    }

    case GET_BIRTHDAY_MESSAGE_SETTINGS:
    case UPDATE_BIRTHDAY_MESSAGE_SETTINGS: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case GET_BIRTHDAY_MESSAGE_SETTINGS_SUCCESS:
    case UPDATE_BIRTHDAY_MESSAGE_SETTINGS_SUCCESS: {
      return produce(state, (draft) => {
        draft.birthdayMessage = payload || initialState.birthdayMessage;
        draft.loading = false;
      });
    }

    case GET_BIRTHDAY_MESSAGE_SETTINGS_ERROR: {
      return produce(state, (draft) => {
        draft.birthdayMessage = initialState.birthdayMessage;
        draft.loading = false;
      });
    }

    case UPDATE_BIRTHDAY_MESSAGE_SETTINGS_ERROR: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    default: {
      return state;
    }
  }
};

export default birthdayMessageReducer;
